export const config = {
  // apiUrl: 'https://ogapi.technogenesis.in/api/V1/AP/',

  apiUrl: 'https://og-test.technogenesis.in/api/V1/AP/',
  // apiUrl: 'https://apioggg.technogenesis.in/api/V1/AP/',
  authRoles: {
    sa: ['SA'], // Only Super Admin has access
    admin: ['SA', 'Admin'], // Only SA & Admin has access
    editor: ['SA', 'Admin', 'Editor'], // Only SA & Admin & Editor has access
    user: ['SA', 'Admin', 'Editor', 'User'], // Only SA & Admin & Editor & User has access
    guest: ['SA', 'Admin', 'Editor', 'User', 'Guest'] // Everyone has access
  }
}